import { render, staticRenderFns } from "./PreviewPdf.vue?vue&type=template&id=20fd5f1b&scoped=true"
import script from "./PreviewPdf.vue?vue&type=script&lang=ts"
export * from "./PreviewPdf.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PreviewPdf.vue?vue&type=style&index=0&id=20fd5f1b&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "20fd5f1b",
  null
  ,true
)

export default component.exports